<template>
  <div class="facebook-post-preview-body">
    <div v-html="msg" class="facebook-post-preview-body__message"></div>

    <shared-social-post-preview-image :title="title" :image="image" />
    <div v-if="title || description" class="facebook-post-preview-body__content">
      <div class="facebook-post-preview-body__info">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/info.svg`"
          alt="Info"
          class="facebook-post-preview-body__icon"
        />
      </div>            
      <div v-if="title" class="facebook-post-preview-body__title">
        {{ title }}
      </div>
      <div v-if="description" class="facebook-post-preview-body__description" v-html="description"></div>
    </div>
  </div>
</template>

<script>
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';
import SharedSocialPostPreviewImage from '../shared/SharedSocialPostPreviewImage';

export default {
  mixins: [extractSocialPostStepPieces],
  components: {SharedSocialPostPreviewImage},
  props: {
    pieces: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.facebook-post-preview-body {
  &__content {
    padding: 10px 0;
    background: #f1f2f6;
    position: relative;
    font-size: 15px;
  }  
  &__title {
    font-weight: bold;
    color: $black-color;
  }

  &__description {
    color: $color-shuttle-grey;
  }
  
  &__title,
  &__description,
  &__message {
    padding: 0 15px;
    word-break: break-word;
  }
  &__message {
    font-size: 15px;
    margin-bottom: 10px;
    color: $black-color;
    line-height: 20px;
  }
  &__info {
    width: 36px;
    height: 36px;
    position: absolute;
    top: -28px;
    right: 30px;
    background: $white-color;
    border: 1px solid rgba($black-color, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  &__icon {
    height: 15px;
  }
}
</style>
